// extracted by mini-css-extract-plugin
module.exports = {"constrainedWidth":"style-module__constrainedWidth___1rLWJ","studyScheduleOverrides":"style-module__studyScheduleOverrides___FAW_h"};